import {AutoCompleteService} from '../../../shared/services/auto-complete.service';
import {FormGroup} from '@angular/forms';
import {PreferenceFacturation, PreferenceFacturationEnum} from '../model/preference-facturation';
import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {PreferenceMessages} from '../../../shared/models/component-messages/preference-messages';
import {PreferencesService} from '../services/preferences.service';
import {first, map, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {Preference, Value} from '../model/preference';
import {InformationComponent} from '../../../shared/modals/information/information.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PreferenceType} from '../../../shared/models/enum/preferenceType';
import {EnumMicroDroits} from '../../../administration/models/micro.droits';
import {AuthorizationService} from '../../../../authorization/services/authorization.service';
import {FacturationService} from '../../../formulaires/common/services/facturation/facturation.service';
import {TypeEntite} from '../model/type-entite.enum';

@Component({
  selector: 'app-preferences-liste-facturation',
  templateUrl: './preferences-liste-facturation.component.html',
  styleUrls: ['./preferences-liste-facturation.component.scss']
})
export class PreferencesListeFacturationComponent implements OnInit, OnDestroy {

  public preferenceMessages = new PreferenceMessages();

  public typeFacturation = PreferenceType.FACTURATION;

  public form: FormGroup;

  private unsubscribe$ = new Subject<void>();

  private siretEtat = '';

  public preferencesTableau: PreferenceFacturation[];
  private idToUpdate = -1;
  public updateMode = false;
  public isGestionComptesFacturation: boolean;
  public isSiretDisabled = false;
  public optionsSelect: any[];
  public optionsSelectType = 'PAYS';

  public selectedTypeEntite: TypeEntite | null;
  public itemEnCours: PreferenceFacturation;

  // Exposé pour comparaison dans le template (*ngIf)
  public readonly TypeEntite = TypeEntite;

  public optionsClasseProfit = [
    {code: 'region', libelle: 'bloc_commun.mapa.getregion'},
    {code: 'departement', libelle: 'bloc_commun.mapa.getdepartement'},
    {code: 'etat', libelle: 'bloc_commun.mapa.getetat'},
    {code: 'debiteurEtranger', libelle: 'bloc_commun.mapa.getdebiteuretranger'},
    {code: 'debiteurPrivePersMorale', libelle: 'bloc_commun.mapa.getdebiteurprivepersmorale'},
    {code: 'debiteurPrivePersPhysique', libelle: 'bloc_commun.mapa.getdebiteurprivepersphysique'},
    {code: 'groupementCollectivites', libelle: 'bloc_commun.mapa.getgroupementcollectivites'},
    {code: 'commune', libelle: 'bloc_commun.mapa.getcommune'},
    {code: 'autresOrganismesPublics', libelle: 'bloc_commun.mapa.getautresorganismespublics'},
    {code: 'etablissementsPublicsSante', libelle: 'bloc_commun.mapa.getetablissementspublicssante'}
  ];

  public radiosValueTypeEntite = [
    {value: TypeEntite.Publique, label: 'stepper.form.facturation.TypeEntitePublique'},
    {value: TypeEntite.PriveeAssujettie, label: 'stepper.form.facturation.TypeEntitePriveeAssujettie'},
  ];

  private readonly mapperPreferenceFacturationEnumToControlName: Record<PreferenceFacturationEnum, string[]> = {
    [PreferenceFacturationEnum.NOM_ORGANISME]: ['preference_SepAtt_facturation_SepAtt_nomOrganisme'],
    [PreferenceFacturationEnum.CLASSE_PROFIT]: ['preference_SepAtt_facturation_SepAtt_classeProfit'],
    [PreferenceFacturationEnum.SIRET]: ['preference_SepAtt_facturation_SepAtt_siret'],
    [PreferenceFacturationEnum.TYPE_ENTITE]: ['preference_SepAtt_facturation_SepAtt_typeEntite'],
    [PreferenceFacturationEnum.IDENTIFIANT_ADRESSAGE]: ['preference_SepAtt_facturation_SepAtt_identifiantAdressage'],
    [PreferenceFacturationEnum.NO_EXECUTANT]: ['preference_SepAtt_facturation_SepAtt_executant'],
    [PreferenceFacturationEnum.BON_COMMANDE]: ['preference_SepAtt_facturation_SepAtt_engagement', 'preference_SepAtt_facturation_SepAtt_refBonCommande'],
    [PreferenceFacturationEnum.ADR1]: ['preference_SepAtt_facturation_SepAtt_destinataire'],
    [PreferenceFacturationEnum.ADR2]: ['preference_SepAtt_facturation_SepAtt_immeuble'],
    [PreferenceFacturationEnum.ADR3]: ['preference_SepAtt_facturation_SepAtt_voie'],
    [PreferenceFacturationEnum.ADR4]: ['preference_SepAtt_facturation_SepAtt_complement'],
    [PreferenceFacturationEnum.CP]: ['preference_SepAtt_facturation_SepAtt_cp'],
    [PreferenceFacturationEnum.PAYS]: ['preference_SepAtt_facturation_SepAtt_pays'],
    [PreferenceFacturationEnum.VILLE]: ['preference_SepAtt_facturation_SepAtt_ville'],
    [PreferenceFacturationEnum.TVA]: ['preference_SepAtt_facturation_SepAtt_tva']
  };

  constructor(private preferencesService: PreferencesService, private modalService: NgbModal,
              private autoCompleteService: AutoCompleteService, private authorizationService: AuthorizationService,
              private facturationService: FacturationService, private cd: ChangeDetectorRef) {
  }


  ngOnInit(): void {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.getAllList();
    this.form = new FormGroup({});
    this.habilitations();
    this.getSiretEtat();
  }

  /**
   * Les contrôles du form ne sont créés que lorsque le *ngIf conditionné par isGestionComptesFacturation
   * s'affiche (chaque app-form-input s'auto-enregistre dans son ngOnInit). Comme cette habilitation est
   * connue de façon asynchrone, ngAfterViewInit s'exécute trop tôt : les contrôles n'existent pas encore
   * et l'abonnement à leurs valueChanges ne se met jamais en place. On appelle donc cette méthode juste
   * après avoir forcé le rendu du *ngIf (voir habilitations()), une fois les contrôles garantis présents.
   */
  private setupFormSubscriptions(): void {
    this.form.get('preference_SepAtt_facturation_SepAtt_classeProfit')?.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        const siretControl = this.form.get('preference_SepAtt_facturation_SepAtt_siret');
        if (value === 'etat' && this.siretEtat) {
          siretControl?.setValue(this.siretEtat);
          siretControl?.disable();
          this.isSiretDisabled = true;
        } else {
          siretControl?.setValue('');
          siretControl?.enable();
          this.isSiretDisabled = false;
        }
      });

    this.form.get('preference_SepAtt_facturation_SepAtt_typeEntite')?.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        this.selectedTypeEntite =
          value === TypeEntite.Publique || value === TypeEntite.PriveeAssujettie ? value : null;
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getAllList() {
    this.preferencesTableau = [];
    this.preferencesService.getFullFacturation()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          data.forEach((el) => {
            const preference = new PreferenceFacturation();
            preference.titre = el.titre;
            for (const loadedPreferenceAttribute of el.content.values) {
              this.setUpPreferenceAttribute(loadedPreferenceAttribute, preference);
            }
            preference.id = el.id;
            this.cleanDataPourTypeEntite(preference);
            this.preferencesTableau.push(preference);
          });
        }
      });
  }

  /**
   * Nettoyage pour ne pas alimenter inutilement des informations fonction du type d'entité.
   * @param preference preference à nettoyer
   * @private
   */
  private cleanDataPourTypeEntite(preference: PreferenceFacturation) {
    if (preference.typeEntite === TypeEntite.Publique) {
      preference.refBonCommande = null;
    }
    if (preference.typeEntite === TypeEntite.PriveeAssujettie) {
      preference.noEngagementJuridique = null;
    }
  }

  private setUpPreferenceAttribute(preferenceAttribute: Value, preference: PreferenceFacturation) {
    switch (preferenceAttribute.code) {
      case PreferenceFacturationEnum.NOM_ORGANISME:
        preference.nomOrganisme = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.CLASSE_PROFIT:
        preference.classeProfit = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.SIRET:
        preference.siret = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.TYPE_ENTITE:
        preference.typeEntite = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.IDENTIFIANT_ADRESSAGE:
        preference.identifiantAdressage = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.BON_COMMANDE:
        preference.noEngagementJuridique = preferenceAttribute.value;
        preference.refBonCommande = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.NO_EXECUTANT:
        preference.noExecutant = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.ADR1:
        preference.serviceOuDestinataire = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.ADR2:
        preference.immeuble = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.ADR3:
        preference.voieAdresse = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.ADR4:
        preference.complement = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.CP:
        preference.codePostal = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.PAYS:
        preference.pays = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.TVA:
        preference.tva = preferenceAttribute.value;
        break;
      case PreferenceFacturationEnum.VILLE:
        preference.ville = preferenceAttribute.value;
        break;

      default:
        break;
    }
  }

  getSiretEtat() {
    this.facturationService.getSiret('etat')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          this.siretEtat = data?.valeur || '';
        }
      });
  }

  savePref(): void {
    const preference = new Preference();

    preference.titre = this.form.get('preference_SepAtt_facturation_SepAtt_intitule')?.value;

    for (const valueEnum of Object.values(PreferenceFacturationEnum)) {
      const preferenceValue = new Value();
      preferenceValue.code = valueEnum;
      preferenceValue.value = this.getFormControlValueForFacturationEnum(valueEnum);
      preference.content.values.push(preferenceValue);
    }

    if (!this.updateMode && this.idToUpdate === -1) {
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = '';
      modalRef.componentInstance.content = this.preferenceMessages.modal_create_text;
      modalRef.componentInstance.OkOuRetour = true;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferencesService.createFacturation(preference)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: ((_data) => {
                    this.annuler();
                    this.getAllList();
                  })
                });
            }
          })
        });
    } else {
      preference.id = this.idToUpdate;
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = '';
      modalRef.componentInstance.content = this.preferenceMessages.modal_update_text;
      modalRef.componentInstance.OkOuRetour = true;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferencesService.updateFacturation(preference)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: ((_data) => {
                    this.annuler();
                    this.getAllList();
                  })
                });
            }
          })
        });
    }
  }

  /**
   * Permet de récupérer pour une valeur d'enum de PreferenceFacturationEnum la valeur qui a été saisi au niveau du formulaire.
   * Quand plusieurs contrôles peuvent être associés à une valeur d'enum, on conserve la valeur du premier contrôle trouvé.
   * En effet, si plusieurs contrôles sont associés à une donnée de facturation, un seul de ces contrôles doit être affiché à l'écran.
   * @param valueEnum valeur de l'énum pour lequel on cherche la valeur dans le formulaire.
   * @private
   */
  private getFormControlValueForFacturationEnum(valueEnum: PreferenceFacturationEnum): string {
    const controleNamesForEnum = this.mapperPreferenceFacturationEnumToControlName[valueEnum];
    for (const formControlName of controleNamesForEnum) {
      if (this.form.get(formControlName)) {
        return this.form.get(formControlName).value;
      }
    }
    return null;
  }

  delete(id: number) {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.content = this.preferenceMessages.modal_delete_text;
    modalRef.componentInstance.OkOuRetour = true;
    modalRef.dismissed.pipe(map((reason: boolean) => {
      return reason;
    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((reason) => {
          if (reason) {
            this.preferencesService.deleteFacturation(id)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe({
                next: (() => {
                  this.annuler();
                  this.getAllList();
                })
              });
          }
        })
      });

  }

  setUpdateMode(item: PreferenceFacturation) {
    this.updateMode = true;
    this.idToUpdate = item.id;
    this.itemEnCours = item;
    this.setupInfosCommunes(item);
  }

  /**
   * Met le formulaire à jour avec les informations de facturation communes et toujours présentées à l'écran
   * Les informations conditionnelles seront initialisées par binding avec les inputs
   * @param item préférence de facturation à afficher
   * @private
   */
  private setupInfosCommunes(item: PreferenceFacturation) {
    this.form.get('preference_SepAtt_facturation_SepAtt_intitule').setValue(item.titre);
    this.form.get('preference_SepAtt_facturation_SepAtt_nomOrganisme').setValue(item.nomOrganisme);
    this.form.get('preference_SepAtt_facturation_SepAtt_classeProfit').setValue(item.classeProfit, {emitEvent: false});
    this.form.get('preference_SepAtt_facturation_SepAtt_siret').setValue(item.siret);
    if (item.classeProfit === 'etat') {
      this.form.get('preference_SepAtt_facturation_SepAtt_siret')?.disable();
      this.isSiretDisabled = true;
    } else {
      this.form.get('preference_SepAtt_facturation_SepAtt_siret')?.enable();
      this.isSiretDisabled = false;
    }
    this.form.get('preference_SepAtt_facturation_SepAtt_typeEntite').setValue(item.typeEntite);
    this.form.get('preference_SepAtt_facturation_SepAtt_destinataire').setValue(item.serviceOuDestinataire);
    this.form.get('preference_SepAtt_facturation_SepAtt_immeuble').setValue(item.immeuble);
    this.form.get('preference_SepAtt_facturation_SepAtt_voie').setValue(item.voieAdresse);
    this.form.get('preference_SepAtt_facturation_SepAtt_complement').setValue(item.complement);
    this.form.get('preference_SepAtt_facturation_SepAtt_cp').setValue(item.codePostal);
    this.form.get('preference_SepAtt_facturation_SepAtt_pays').setValue(item.pays);
    this.form.get('preference_SepAtt_facturation_SepAtt_ville').setValue(item.ville);
    this.form.get('preference_SepAtt_facturation_SepAtt_tva').setValue(item.tva);
  }

  annuler(): void {
    this.form.get('preference_SepAtt_facturation_SepAtt_siret')?.enable();
    this.isSiretDisabled = false;
    this.form.reset();
    this.updateMode = false;
    this.idToUpdate = -1;
    this.itemEnCours = undefined;
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.DONNEES_FACTURATIONS_GESTION])
      .pipe(first())
      .subscribe(isGestionComptesFacturation => {
        this.isGestionComptesFacturation = isGestionComptesFacturation;
        if (isGestionComptesFacturation) {
          // Force le rendu du *ngIf du form (et donc l'auto-enregistrement des contrôles
          // par les app-form-input) avant de s'abonner à leurs valueChanges.
          this.cd.detectChanges();
          this.setupFormSubscriptions();
        }
      });
  }
}
